<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        อัปโหลดไฟล์
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการข้อมูลโทรศัพท์เคลื่อนที่
          </a>
        </li>
        <li class="active">อัปโหลดไฟล์</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-body" v-loading="loading">
                <div id="alert-group" v-if="fileType != 'pdf'">
                  <el-alert v-if="missings.length > 0"
                    title="แจ้งเตือน"
                    type="error"
                    show-icon
                    :closable="false"
                    >
                    พบรายการส่งเสริมการขายที่ยังให้บริการอยู่และไม่ได้นำส่งในรอบปัจจุบันทั้งหมด {{missings.length}} รายการ
                    <div v-for="(item,index) in missings" :key="index">{{1+index+'. รายการส่งเสริมการขายรหัส '+item}}</div> 
                  </el-alert><br>
                  <el-alert
                    :title="'จำนวนและสัดส่วนร้อยละแยกตามประเภทเทคโนโลยีของการให้บริการ'"
                    type="success"
                    :closable="false"
                    show-icon
                    >
                    FTTx จำนวน {{ preview_data.count['fttx'] }} รายการ คิดเป็นอัตราส่วนร้อยละ {{ preview_data.percent['fttx'] }} % <br/>
                    ADSL จำนวน {{ preview_data.count['adsl'] }} รายการ คิดเป็นอัตราส่วนร้อยละ {{ preview_data.percent['adsl'] }} % <br/>
                    VDSL จำนวน {{ preview_data.count['vdsl'] }} รายการ คิดเป็นอัตราส่วนร้อยละ {{ preview_data.percent['vdsl'] }} % <br/>
                    WiFi จำนวน {{ preview_data.count['wifi'] }} รายการ คิดเป็นอัตราส่วนร้อยละ {{ preview_data.percent['wifi'] }} % <br/>
                    VAS จำนวน {{ preview_data.count['vas'] }} รายการ คิดเป็นอัตราส่วนร้อยละ {{ preview_data.percent['vas'] }} % <br/>
                    รวมทั้งหมด จำนวน {{ preview_data.count['total'] }} รายการ <br/>
                  </el-alert><br>
                  <el-alert
                    :title="'อัตราค่าบริการเฉลี่ยแยกตามประเภทเทคโนโลยีของการให้บริการ'"
                    type="success"
                    :closable="false"
                    show-icon
                    >
                    <table>
                      <tr>
                        <td>เทคโนโลยี</td>
                        <td>ค่าบริการเฉลี่ย</td>
                        <td>หน่วย</td>
                      </tr>
                      <tr v-for="(item,index) of preview_data.average" :key="index">
                        <td>{{ index }}</td>
                        <td>{{ item}}</td>
                        <td>บาท/Mbps</td>
                      </tr>
                    </table>
                  </el-alert>
                </div>
                <data-tables
                  :data="table_data"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  :table-props="tableProps"
                >
                  <el-table-column
                   sortable
                   v-for="(col,index) in schema_en"
                   :key="index"
                   :prop="col"
                   :label="schema_th[index]"
                   :width="schema_th[index].toString().length*10.5"
                   show-overflow-tooltip height="250"
                    >
                  </el-table-column>
                </data-tables>
                <div class="wrapper_confirm_promotion box-body" ><br>
                  <b v-if="!errors.length">ยืนยันการนำเข้าข้อมูลรายการส่งเสริมการขายประจำเดือน{{ month_title }} </b>
                  <div v-if="show_err">
                    <div style="margin-bottom: 30px; margin-top: 30px">
                      <b>ไม่สามารถนำเข้าข้อมูลรายการส่งเสริมการขายได้เนื่องจากพบข้อมูลผิดพลาดทั้งหมด {{errors.length}} รายการ</b>
                      <el-button
                        :disabled="pending"
                        @click="exporting()"
                        class="pull-right"
                        type="success"
                        size="small"
                      >
                        Export
                      </el-button>
                    </div>
                    <el-table
                      :data="errors"
                      :row-class-name="tableRowClassName"
                      :header-row-class-name="headerClass">
                      <el-table-column
                        prop="row"
                        label="แถว"
                        width="75">
                      </el-table-column>
                      <el-table-column
                        prop="row"
                        label="รหัสรายการส่งเสริมการขาย"
                        width="150">
                        <template slot-scope="scope">
                          {{ table_data[scope.row.row-9].promotion_code || '' }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="col"
                        label="ชื่อคอลัมน์">
                        <template slot-scope="scope">
                          {{ schema_th[scope.row.col] }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="col"
                        label="ข้อมูล">
                        <template slot-scope="scope">
                          {{ table_data[scope.row.row-9][schema_en[scope.row.col]] }}
                        </template>
                      </el-table-column>
                      <el-table-column 
                        prop="type"
                        label="คำอธิบาย">
                        <template slot-scope="scope">
                          <template v-if="scope.row.type == 'diffs'">
                            {{ "พบการเปลี่ยนแปลงข้อมูล" }}<br>
                            {{ "ข้อมูลใหม่ : "+scope.row.new }}<br>
                            {{ "ข้อมูลเดิม : "+scope.row.old }}
                          </template>
                          <template v-else>
                            {{ scope.row.detail }}
                          </template>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <br><br>
                  <el-button
                    size="small"
                    type="primary"
                    @click="cancelUpload"
                  >ย้อนกลับ</el-button>
                  <el-button
                    size="small"
                    type="success"
                    @click="submitUpload"
                    :disabled="(!!errors.length) || sending"
                  >ตกลง</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>

<style>
  .el-table .header-row{
    background: lightslategray;
  }
  .el-table .warning-row {
    background: #ffe3ba;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-table .info-row {
    background: #c1e0ff;
  }
  .el-table .danger-row {
    background: #fdbdbd;
  }
</style>

<script>
import { mapState,mapActions } from "vuex"
import { parse } from "json2csv"
export default {
  data() {
    return {
      admin_id : null,
      selectDate: '',
      type: '',
      tableProps: {
        border: true
        // stripe: true,
      },
      data: [],
      sending : false,
      show_err : false,
      pending : false,
      tableRowClassName : function({row, rowIndex}) {
        var color_class = {
          diffs : 'info-row',
          required : 'danger-row'
        }
        return color_class[row.type] ? color_class[row.type] : ''
      }
    }
  },
  mounted(){
    this.$store.dispatch('Manage_internet/get_provider_id')
    const userinfo = this.$cookies.get("user_nbtc")
    this.admin_id = userinfo.admin_id
    if(!this.monthly) this.$router.push({name : 'Operator_Manage_internet'})
  },
  computed: {
    ...mapState({
      table_data : store => store.Manage_internet.prepares,
      errors : store => store.Manage_internet.errors,
      missings : store => store.Manage_internet.missings,
      filePath : store => store.Manage_internet.file_path,
      fileType : store => store.Manage_internet.file_type,
      loading : store => store.Manage_internet.loading,
      schema_en : store => store.Manage_internet.broadband_schema_en,
      schema_th : store => store.Manage_internet.broadband_schema_th,
      month_title : store => store.Manage_internet.month_title,
      preview_data : store => store.Manage_internet.preview_data,
      monthly : store => store.Manage_internet.monthly
    })
  },
  watch: {
    table_data : {
      handler : function(reload){
        this.show_err = !!this.errors.length
      }
    }
  },
  methods: {
    ...mapActions({
      prepare : "Manage_internet/prepareTable",
      confirm : "Manage_internet/confirmUpload",
      cancel : "Manage_internet/cancelUpload"
    }),
    submitUpload() {
      this.sending = true
      this.confirm()
    },
    cancelUpload() {
      this.cancel()
    },
    headerClass({row, rowIndex}){
      return 'header-row'
    },
    async exporting(){
      this.pending = true
      try {
        const err_log = await this.$store.dispatch('Manage_internet/create_export_data')
        const csv = parse(err_log);
        var csvContent = 'data:application/vnd.ms-excel;csvcharset=GBK,\uFEFF' + encodeURIComponent(csv)
        var link = document.createElement('a')
        document.body.appendChild(link)
        link.setAttribute('href', csvContent)
        link.setAttribute('download', `upload_error_log.xls`)
        link.click()
        document.body.removeChild(link)
        setTimeout(() => {
          this.pending = false
        }, 1000);
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>